var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcReservationmeetingOn = function SvgIcReservationmeetingOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_reservationmeeting_on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.833 0H15.167C6.79 0 0 6.79 0 15.167v21.666C0 45.21 6.79 52 15.167 52h21.666C45.21 52 52 45.21 52 36.833V15.167C52 6.79 45.21 0 36.833 0Z",
    fill: "#E9F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16.25c.888 0 1.625.737 1.625 1.625v6.5h3.25c.888 0 1.625.737 1.625 1.625s-.737 1.625-1.625 1.625H26A1.637 1.637 0 0 1 24.375 26v-8.125c0-.888.737-1.625 1.625-1.625Z",
    fill: "#E9F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.836 26c0 8.385 6.782 15.166 15.167 15.166S41.169 34.385 41.169 26c0-8.385-6.781-15.167-15.166-15.167-8.385 0-15.167 6.782-15.167 15.167Zm13.65-7.584c0-.845.672-1.516 1.517-1.516.845 0 1.516.671 1.516 1.516v6.067h3.034c.845 0 1.516.672 1.516 1.517 0 .845-.671 1.516-1.516 1.516h-4.55A1.507 1.507 0 0 1 24.486 26v-7.584Z",
    fill: "#6ACDF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_reservationmeeting_on_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
};
export default SvgIcReservationmeetingOn;